import React from 'react';
import { toastr } from 'react-redux-toastr';
import PropTypes from 'prop-types';
import { FormText, Input, UncontrolledTooltip } from 'reactstrap';
import { inputPropTypes, metaPropTypes } from './InputPropTypes';

const DEFAULT_MAX_FILE_SIZE = 1 * 1024 * 1024;

const toMegabytes = (bytes) => Math.round(bytes / 1024 / 1024);

const FileInput = ({
  id,
  input: { onChange, onBlur, name, value },
  meta: { touched, error, warning },
  disabled,
  invalid,
  className,
  placeholder,
  showToolTip,
  accept,
  multiple,
  maxFileSize,
}) => {
  const inputId = id || `${name}-file`;

  const handleChange = (e) => {
    const { files } = e.target;

    if (!files || files.length === 0) {
      onChange(null);
      return;
    }

    const fileList = multiple ? Array.from(files) : [files[0]];
    const invalidFile = fileList.find((file) => file.size > maxFileSize);

    if (invalidFile) {
      onChange(null);

      e.target.value = '';

      toastr.error(
        'Error',
        `El archivo "${
          invalidFile.name
        }" excede el tamaño máximo permitido de ${toMegabytes(
          maxFileSize,
        )} MB.`,
      );
      return;
    }

    onChange(multiple ? fileList : fileList[0]);
  };

  const handleBlur = () => onBlur(value);

  const toolTipComponent =
    showToolTip && placeholder ? (
      <UncontrolledTooltip placement="top" target={inputId}>
        {placeholder}
      </UncontrolledTooltip>
    ) : null;

  return (
    <div style={{ width: '100%' }}>
      <Input
        id={inputId}
        type="file"
        name={name}
        disabled={disabled}
        invalid={invalid}
        className={className || 'form-control'}
        style={{ width: '100%' }}
        accept={accept}
        multiple={multiple}
        onChange={handleChange}
        onBlur={handleBlur}
      />

      {toolTipComponent}

      <FormText color="danger">
        {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </FormText>

      <FormText color="muted">
        {`Tamaño máximo permitido: ${toMegabytes(maxFileSize)} MB`}
      </FormText>
    </div>
  );
};

FileInput.propTypes = {
  id: PropTypes.string,
  input: inputPropTypes.isRequired,
  meta: metaPropTypes.isRequired,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  showToolTip: PropTypes.bool,
  accept: PropTypes.string,
  multiple: PropTypes.bool,
  maxFileSize: PropTypes.number,
};

FileInput.defaultProps = {
  id: null,
  disabled: false,
  invalid: false,
  className: '',
  placeholder: '',
  showToolTip: false,
  accept: undefined,
  multiple: false,
  maxFileSize: DEFAULT_MAX_FILE_SIZE,
};

export default FileInput;
